import axios from "axios";
import api from "./api";
import { ITipoSystem } from "interfaces/typesystem";

export interface ICep {
  cep?: string;
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro: boolean;
}

/**
 * Verifica se o CEP informado tem 8 digitos,
 * realiza uma chamada para a API do ViaCEP e
 * retorna o endereco formatado
 * @param cep CEP informado
 * @returns Objeto com o endereco formatado
 */
export const getCep = async (cep: string): Promise<ICep> => {
  const parseCep = cep.replace(/[^0-9]/g, "");
  // Checar se o cep possui os 8 digitos
  if (parseCep.length < 8 || parseCep.length > 8) {
    return { erro: true };
  }

  try {
    const response = await axios.get<ICep>(
      `https://viacep.com.br/ws/${parseCep}/json/`
    );

    const {
      cep,
      logradouro,
      bairro,
      localidade,
      uf,
      erro = false,
    } = response.data;

    return { cep, logradouro, bairro, localidade, uf, erro };
  } catch (error) {
    return { erro: true };
  }
};

/**
 * Realiza uma chamada para a API e retorna o tipo constante sistema
 * @returns Objeto com as constantes do sistema
 */
export const getType = async (): Promise<ITipoSystem> => {
  try {
    // Realiza uma chamada para a API do tipo de evento
    const { data } = await api.get<ITipoSystem>("/types");
    return data;
  } catch (error) {
    // Caso ocorra um erro, lan a um erro customizado
    throw new Error("Falha na comunicação com a API do tipo de evento");
  }
};

/**
 * Formata um telefone no padrão (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
 * @param {string} telefone Telefone a ser formatado
 * @returns {string} Telefone formatado
 */
export function formatarTelefone(telefone: string) {
  // Remove todos os caracteres n o num ricos
  telefone = telefone.replace(/\D/g, "");

  // Formata o telefone no padr o (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
  if (telefone.length === 11) {
    return `(${telefone.substring(0, 2)}) ${telefone.substring(2, 7)}-${telefone.substring(7, 11)}`;
  } else if (telefone.length === 10) {
    return `(${telefone.substring(0, 2)}) ${telefone.substring(2, 6)}-${telefone.substring(6, 10)}`;
  }

  // Retorna o telefone original se não for possível formatar corretamente
  return telefone;
}

/**
 * Formata um CPF no padrão XXX.XXX.XXX-XX
 * @param {string} cpf CPF a ser formatado
 * @returns {string} CPF formatado
 */
export function formatarCPF(cpf: string) {
  // Remove todos os caracteres n o num ricos
  cpf = cpf.replace(/\D/g, "");

  // Verifica se o CPF possui 11 caracteres
  if (cpf.length === 11) {
    // Formata o CPF no padr o XXX.XXX.XXX-XX
    return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(6, 9)}-${cpf.substring(
      9,
      11
    )}`;
  }

  // Retorna o CPF original se n o for poss vel formatar corretamente
  return cpf;
}
